import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: []
  },
  getters: {
    list: state => state.list,
    details: state => state.details
  },
  actions: {
    fetch({ commit, dispatch }, model) {
      return ajax.get("IdentityAccess/api/UsersQuery", model).then(r => {
        commit("setList", r.data.data);
      });
    },
    fetchByRoleId({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("IdentityAccess/api/UsersQuery/" + id + "/UserRole")
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("IdentityAccess/api/Users", model).then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "IdentityAccess/api/Users",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax.put("IdentityAccess/api/Users", model).then(() => {});
    },
    updateUserRoles({ commit, dispatch }, model) {
      return ajax.post("IdentityAccess/api/UserRoles", model).then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
};
